let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fT1qw")).then(() => parcelRequire('h16RV'));